import { gql } from '@apollo/client'

export const SlotsAvailable = gql`
    query SlotsAvailable {
        user {
            id
            roomSlotsAvailable
        }
    }
`

export default SlotsAvailable

